import { render, staticRenderFns } from "./reply-msg.vue?vue&type=template&id=c27a2bcc"
import script from "./reply-msg.vue?vue&type=script&lang=js"
export * from "./reply-msg.vue?vue&type=script&lang=js"
import style0 from "./reply-msg.vue?vue&type=style&index=0&id=c27a2bcc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports